import { styled } from '@mui/material';

export interface PairProps {
  name: string;
  value: string;
}

export function Pair({ name, value }: PairProps) {
  return (
    <Wrapper>
      <Name> {name}:</Name>
      <Value>{value}</Value>
    </Wrapper>
  );
}

const Wrapper = styled('span')(() => ({ display: 'block' }));
const Name = styled('span')(() => ({ fontWeight: 700 }));
const Value = styled('span')(() => ({ marginLeft: '0.5rem' }));
